import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionModuleEnum, ActionsService } from '@brafton/angular-framework-library';
import { ProjectHelper } from 'src/app/core/utils/project.helper';

const approvalArray = [
  '5a3278140adf480001b52ab3',
  '5a0c6e3af9b5a35db0f54b73',
  '5c58280eb2f3f80001708c7b',
  '5c58281bb2f3f80001708c7c',
  '5a3278140adf480001b52ab3', // ideation approval
];
@Component({
  selector: 'content-task-row',
  templateUrl: './content-task-row.component.html',
  styleUrls: ['./content-task-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContentTaskRow implements OnInit {
  @Input() task?: any;
  @Input() phase?: any;
  @Input() location?: 'admin' | 'productions' | 'ideation' | 'content';
  @HostBinding('class') class = '';

  constructor(
    private projectHelper: ProjectHelper,
    private actionsService: ActionsService,
  ) {}

  ngOnInit(): void {
    this.class = `task-row ${this.task.status.id}`;
  }

  isApproval(): string | null {
    if (approvalArray.includes(this.task?.workType)) {
      return 'subdirectory_arrow_left';
    } else {
      return null;
    }
  }

  openAction(setAction?: string) {
    const phase = this.projectHelper.findPhase(this.task);
    const project = this.projectHelper.findProject(this.task);
    const getmoduleType = this.projectHelper.getModuleType(this.task) as ActionModuleEnum;
    const moduleType = this.checkLocation(getmoduleType) as ActionModuleEnum;

    this.actionsService.changeActions(setAction as string, moduleType, undefined, project, phase, this.task, 'task');
  }

  checkLocation(location: string): ActionModuleEnum {
    if (location === 'productions') return ActionModuleEnum.production;
    if (location === 'ideations') return ActionModuleEnum.ideation;
    return location as ActionModuleEnum;
  }

  hasAction(actionId: string): boolean {
    if (!this.task) return false;
    return this.task?.actions?.some((a: any) => a.isEnabled && a.actionEnum?.id == actionId) ? true : false;
  }
}
